const toNumber = (value) => {
  const num = Number(value);
  return Number.isFinite(num) ? num : 0;
};

export function getPlanBasePrice(plan) {
  return Math.max(0, toNumber(plan?.price));
}

export function getPlanDiscountAmount(plan) {
  const basePrice = getPlanBasePrice(plan);
  const discountType = String(plan?.discount_type || "").toLowerCase();
  const rawDiscount = Math.max(0, toNumber(plan?.discount_amount));

  if (!rawDiscount || !basePrice) return 0;

  if (discountType === "percentage") {
    return Math.min(basePrice, (basePrice * rawDiscount) / 100);
  }

  if (discountType === "fixed") {
    return Math.min(basePrice, rawDiscount);
  }

  return 0;
}

export function getPlanDiscountPercent(plan) {
  const basePrice = getPlanBasePrice(plan);
  if (!basePrice) return 0;

  return (getPlanDiscountAmount(plan) / basePrice) * 100;
}

export function hasPlanDiscount(plan) {
  return getPlanDiscountAmount(plan) > 0;
}

export function getDiscountedPlanPrice(plan) {
  return Math.max(0, getPlanBasePrice(plan) - getPlanDiscountAmount(plan));
}

export function getPlanDisplayPrice(plan) {
  return getDiscountedPlanPrice(plan);
}

export function getYearlySavingsSummary() {
  return {
    hasSavings: false,
    label: "Annual licence model",
    maxPercent: 0,
  };
}
